// extracted by mini-css-extract-plugin
module.exports = {"home":"home__1E5DY","link":"link__1MKes","link--small":"link--small__3Btp7"};